import type { ReactNode } from 'react';
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="flex justify-between items-end gap-6 mb-6">
      <div>
        <h1 className="text-h2 font-bold text-ink -tracking-[0.4px]">
          {title}
        </h1>
        {subtitle && (
          <div className="text-body text-ink-2 mt-1">{subtitle}</div>
        )}
      </div>
      {actions && <div className="flex gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
